import React, { Component } from 'react'
import './styles.scss'
import connector from 'src/decorators/connector'
import { IStoresMap } from 'src/types'
import Item from "./item"


class AppPage extends Component<ReturnType<typeof storesToProps>> {

    public render() {
        const { housePlates } = this.props.configuratorStore
        const { addProduct } = this.props.busket
         const element = document.getElementById('goods');
         let googds = element?.textContent || element?.innerText;
         const n=googds?.lastIndexOf(",") as number;
         googds = googds?.substring(0, n) as string + googds?.substring(n + 1);
         const json = JSON.parse(googds as string)
         const catname = document.getElementById('catname')?.innerText;
 
        return (<>
            <div className="goods">
                <div className='title'>Все таблички {catname}</div>
                <div className="container-goods">
                    {json.goods.map((item: any, index: number) => <div key={index} className="col-goods">
                                <Item key={index} item={item} addProduct={addProduct} />
                            </div>)}
                </div>
            </div>
        </>
        )
    }
}

const storesToProps = ({ store }: IStoresMap) => ({
    configuratorStore: store.configuratorStore,
    busket: store.BusketStore
})

export default connector(storesToProps)(AppPage)